import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { Button, CircularProgress } from "@nextui-org/react";
import { useGlobalData } from "@/contexts/GlobalData";
import LottieAnimation from "../LottieAnimation";
import getAnimation from "@/common/function/getAnimation";
export type ButtonStatus = "normal" | "disabled" | "loading" | "processing" | "error" | "success";
interface SecondaryButtonPropsType extends GeneralPropsType {
  status: ButtonStatus;
  hideStatusText: boolean;
  statusKey: string;
}
function SecondaryButton({
  children,
  className,
  status = "normal",
  statusKey,
  hideStatusText,
  ...rest
}: SecondaryButtonPropsType | any) {
  const {
    translate
  } = useGlobalData();
  return <button className={clsx("rounded-full", styles.button, styles[status], styles.button_text, className)}
  // disabled={status == "loading" || status == "disabled"}
  disabled={status != "normal"} {...rest} data-sentry-component="SecondaryButton" data-sentry-source-file="index.tsx">
            {(status === "normal" || status === "disabled") && (children ?? translate(`${statusKey}_normal`))}
            {status != "normal" && status != "disabled" && <div className="flex items-center gap-2 justify-center">
                    {status == "loading" && <CircularProgress aria-label="Loading..." color="secondary" classNames={{
        svg: "w-6 h-6"
      }} />}
                    {status == "success" && <LottieAnimation src={getAnimation("success_button")} loop={false} autoplay={true} className="w-6 h-6" />}
                    {status == "error" && <LottieAnimation src={getAnimation("error_button")} loop={false} autoplay={true} className="w-6 h-6" />}

                    {!hideStatusText && <span>
                            {statusKey ? translate(`${statusKey}_${status}`) : rest[`${status}-message`] ?? translate(`button_${status}_message`)}
                        </span>}
                </div>}
        </button>;
}
export default SecondaryButton;